/**
 * Copy do OBJETIVO do aluno — o que ele quer ser depois da residencia.
 *
 * Primeiro modulo de `src/lib/copy/` (R4 da r6-30; a r6-26 encontra a pasta ja criada e
 * importa daqui em vez de refazer). A organizacao e por CONCEITO, nao por tela: o mesmo
 * rotulo aparece nas Configuracoes (`features/settings/GoalSection.tsx`) e na pergunta 10
 * do formulario de entrada (`features/onboarding/questions.ts`). Um `settings.ts` mais um
 * `onboarding.ts` obrigariam a repetir a string — e a repeticao e exatamente o defeito que
 * a r6-30 veio consertar, porque foi assim que "Especialidade desejada" sobreviveu em dois
 * lugares depois da r6-23.
 *
 * r6-30 REVOGA a decisao 4.1 da r6-23: o aluno le "Objetivo"; o admin continua com
 * "Objetivos" no plural, porque la e o catalogo (`career_goals`), uma lista.
 *
 * R12-04 (reuniao de 15/10) REVOGA o rotulo da r6-30: "Objetivo" confundia. O aluno le
 * "Especialidade pretendida" (a especialidade medica dentro do processo seletivo dele) e
 * o admin le "Especialidades medicas" no catalogo. O nome do export continua
 * OBJECTIVE_COPY para nao espalhar renomeacao de simbolo; o que mudou e so o texto.
 * O catalogo da prova (Specialty) virou "Grandes areas" na tela: `examAreas.ts`.
 *
 * O que NAO muda junto com o texto: a coluna `users.sub_desired_speciality`, a FK
 * `career_goal_id`, o `id` `desired_specialties` (persistido no jsonb
 * `onboarding_responses.answers`) e a sentinela `DESIRED_SPECIALTY_OTHER` ('__outra__').
 * Sem barrel/`index.ts`: outros modulos de copy nascem nesta pasta em paralelo.
 */
export const OBJECTIVE_COPY = {
  /** Titulo da secao de Configuracoes (`#objetivo`, ancora mantida por links salvos). */
  sectionTitle: 'Metas',
  sectionDescription:
    'Especialidade pretendida, cursinho e instituições prioritárias — é o que orienta as recomendações.',
  /** Rotulo do select. */
  fieldLabel: 'Especialidade pretendida',
  fieldHint:
    'A especialidade médica que você quer seguir, dentro do seu processo seletivo — não é o que a prova cobra.',
  fieldPlaceholder: 'Selecione a especialidade pretendida',
  /** Campo livre da opcao "Outra": e um `<Input>` sem `<label>`, o aria-label e a unica etiqueta. */
  otherAriaLabel: 'Especialidade pretendida, escrita por você',
  otherPlaceholder: 'Escreva a especialidade',
  /** Pergunta 10 do formulario de entrada. */
  onboardingLabel: 'Qual especialidade você pretende seguir?',
  onboardingHint:
    'A lista muda conforme o processo seletivo escolhido acima — não é o que a prova cobra.',
  /** Pergunta 10b (campo livre), que repete o enunciado porque aparece sozinha embaixo. */
  otherFieldLabel: 'Qual especialidade você pretende seguir?',
  /** Catalogos > (career_goals) no admin: a lista, por processo seletivo. */
  catalogTitle: 'Especialidades médicas',
  catalogSingular: 'Especialidade médica',
} as const
